<template>
    <div class="is-flex">
        <div class="text-column">
            <render-editor-js :content="content.columns[0].content" :component="{}"/>

        </div>
        <div class="text-column">
            <render-editor-js :content="content.columns[1].content" :component="{}"/>

        </div>
    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        components: {RenderEditorJs},
        props: ['content'],
        methods: {

        },
        created() {

        }
    };
</script>

<style scoped lang="scss">
    .text-column {
        position: relative;
        flex: 1 1 50%;
    }
</style>
